import { createStore } from 'vuex'

export default createStore({
  state: {
    area_level:10,
    area_pid:0
  },
  getters:{
    area_level: state => state.area_level,
    area_pid: state => state.area_pid,
  },
  mutations: {
    updateAreaLevel:(state, level) => state.area_level = level,
    updateAreaId:(state, pid) => state.area_pid = pid,
  },
  actions: {
  },
  modules: {
  }
})
